import * as actions from "Actions";
import * as api from "Api";

export const fetchUsers = () => {
  return (dispatch, getState) => {
    const { currentOrganization } = getState().auth;
    const { searchWord, role } = getState().authorizationsSettings.filter;
    let organizationId = currentOrganization.id;

    return dispatch(
      actions.getUsersSettings(
        api.getUsersSettings(searchWord, role, organizationId)
      )
    );
  };
};

export const updateUsersSettings = () => {
  return (dispatch, getState) => {
    let {
      role,
      selectedUsers,
      allowAccessToDashboardList,
      allowAssociateDashboards,
      allowCreateDashboard,
      allowAccessToCollaboratorList,
      allowUpdateSlide,
      allowCreateSlide,
      allowAccessToSlideList,
      allowAccessToSettings,
      allowUpdateDashboard
    } = getState().authorizationsSettings;
    let clientId = getState().auth.currentOrganization.id;

    let selectedUsersIds = selectedUsers.map(user => user.id);

    if (role !== "NONE") {
      return dispatch(
        actions.saveUsers(
          api
            .saveUsersSettings(
              role,
              allowCreateDashboard,
              allowAccessToDashboardList,
              allowAssociateDashboards,
              allowAccessToCollaboratorList,
              allowUpdateSlide,
              allowCreateSlide,
              allowAccessToSlideList,
              allowAccessToSettings,
              allowUpdateDashboard,
              selectedUsersIds,
              clientId
            )
            .then(res =>
              dispatch(
                actions.updateUsers({
                  role,
                  allowCreateDashboard: allowCreateDashboard,
                  allowAccessToDashboardList: allowAccessToDashboardList,
                  allowAssociateDashboards: allowAssociateDashboards,
                  allowAccessToCollaboratorList: allowAccessToCollaboratorList,
                  allowUpdateSlide: allowUpdateSlide,
                  allowCreateSlide: allowCreateSlide,
                  allowAccessToSlideList: allowAccessToSlideList,
                  allowAccessToSettings: allowAccessToSettings,
                  allowUpdateDashboard: allowUpdateDashboard,
                  selectedUsers: selectedUsersIds
                })
              )
            )
        )
      );
    } else {
      return dispatch(
        actions.saveUsers(
          api.deleteUsersSettings(selectedUsersIds, clientId).then(res =>
            dispatch(
              actions.updateUsers({
                selectedUsers: selectedUsersIds
              })
            )
          )
        )
      );
    }
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/authorizations.js